// client/src/components/pages/PeriodSummary/routeBoundary.ts
//
// The line between one key's row (table) or lane (timeline) and the next (ST-00209).
//
// It used to be `border-gray-100`: #f3f4f6 on the white surface in light mode, and in dark
// mode rgb(22 29 38) on the #161b22 surface, which is close to invisible. In the timeline
// it was also fainter than the lane's own zero baseline (`bg-gray-200`), so a lane's
// receipt bars (down) ran straight into the next lane's dispatch bars (up) with nothing
// to tell them apart. `gray-300` is the `--border-strong` step in both themes (#d1d5db
// light, rgb(55 66 80) dark), one step above the baseline: the boundary between keys now
// reads first, the baseline second, the dashed 50% marks last. Lines inside a key (the
// breakdown and ticket tables of an expanded key) keep their subtle `gray-100`.
export const ROUTE_BOUNDARY_CLASS = 'border-t border-gray-300';
